// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__PPQ9A","cardDisabled":"Card_cardDisabled__1HHoR","cardHover":"Card_cardHover__1bqFM"};